import axios from "axios";
import { ProjectModel, ProjectToJsonWithoutId } from "../../../base/models/projectModel";
import { SettingsFromLocalStorage } from "../components/settingFileView";

export async function addNew(project: ProjectModel) {
  try {
    const headers = SettingsFromLocalStorage();
    const token = localStorage.getItem("token");

    const data = ProjectToJsonWithoutId(project);

    // console.log(data);

    const response = await axios(
      "https://emresn-info-default-rtdb.europe-west1.firebasedatabase.app/projects.json",
      {
        method: "POST",
        data: data,
        headers: {
          "Content-Type": "application/json",
          ...headers,
        },
        params: {
          auth: token,
        },
      }
    );

    return response;
  } catch (error) {
    throw new Error(`${error}`);
  }
}
